import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';
import {SecurityService} from '../services/security.service';
import {VisualsService} from '../services/visuals.service';

@Component({
  selector: 'sidebar',
  templateUrl: './menu.component.html',
})
export class MenuComponent implements OnInit {
  public menus: any;
  public genericVisuals: any = {};
  public config: any = {};

  constructor(
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    public router: Router,
    public logger: LogService,
    public visualsService: VisualsService,
  ) {
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.Menus();
        this.getVisuals();
      },
    });
  }

  ngOnInit() {
    this.Menus();
    this.getVisuals();
  }

  public Menus() {
    this.menus = this.visualsService.getFromStorageAsJSON('menusArray');
  }

  public getVisuals() {
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
  }
}
